import React from 'react';
import headerImg from '../../../assets/img/quiz-header.jpeg';
import './Header.scss';

const Header = () => {
    return (
        <div className="quiz-header">
            <img id='header__background-img' src={headerImg} alt="quiz-header-image" />
            
            <div className='header__content'>
                <h1 id='header__title'>Style Quiz</h1>
            </div>
        </div>
    );
};

export default Header;